import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import "./App.css"
import openIC from "./image/open.svg"
import downloadIC from "./image/download.svg"
import QRIC from "./image/qr.svg"
import logo from "./image/logo.svg"
import phone from "./image/phone-bg.png"

const App = () => {
  const location = useLocation();

  useEffect(() => {
    const pathSegments = location.pathname.split('/');
    const cardIndex = pathSegments.findIndex(segment => segment === 'cardscan');
    const cardId = cardIndex !== -1 ? pathSegments[cardIndex + 1] : null;

    if (!cardId) return;
    const fallback = {
      android: 'https://play.google.com/store/apps/details?id=com.ecologital.rewardstick_consumer_app',
      ios: `https://apps.apple.com/app/com.ecologital.rewardstick_consumer_app`,
      web: `https://deeplink.throbox.com/rewardstick/cardscan/${cardId}`,
    };

    const userAgent = navigator.userAgent || navigator.vendor;
    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(userAgent);

    if (isAndroid) {
      const intentUrl = `intent://cardscan/${cardId}#Intent;scheme=rewardstick;package=com.ecologital.rewardstick_consumer_app;end`;
      window.location.href = intentUrl;

      setTimeout(() => {
        window.location.href = fallback.android;
      }, 1500);
    } else if (isIOS) {
      window.location.href = `rewardstick://cardscan/${cardId}`;

      setTimeout(() => {
        window.location.href = fallback.ios;
      }, 1500);
    } else {
      window.location.href = fallback.web;
    }
  }, [location]);

  return (
    <div className='App'>
      <img alt='' src={logo} className='logo-style' />
      {/* <img alt='' src={phone} className='phinebg-style' /> */}

      <div className='App-container'>
        <div className='App-inner-container'>
          <div className='qr-wrapper'>
            <img alt='' src={QRIC} className='qr-img' />
          </div>
          <div className='inner-container-header'>Join using <div className='header-bold'>Rewardstick</div></div>
          <div className='redirect-text'>Redirecting to you app <div className='timer-text'>1 sec</div></div>
          <div className='open-btn'><img alt='' src={openIC} className='open-ic' />Open App</div>
          <div className='download-btn'> <img alt='' src={downloadIC} className='download-ic' />Download App</div>
          <div className='privacy-content'>
            <div>© 2025 Loyalty Scanner Inc. All rights reserved.</div>
            <div className='policy'><span>Privacy Policy</span>
              <span>Terms of Service</span></div>

          </div>
        </div>
      </div>
    </div>);
};

export default App;
